import { useTranslation } from 'react-i18next';

import { useAuthenticatedUser, useFeature } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Button, Jumbo } from '@treams/treams-ui';

import Announcement from '../announcements/Announcement';
import IncomingConversationsList from './IncomingConversationsList';
import ViewerConversationTabs from './ViewerConversationTabs';

export default function ViewerIncomingConversations() {
	const { t } = useTranslation();
	const userID = useAuthenticatedUser().id;
	const isAdhocEnabled = useFeature(graphql.FeatureName.EvaluationsAdhoc);
	const isConversationsAIInsightsEnabled = useFeature(graphql.FeatureName.ConversationAiInsights);

	const query = graphql.useEvaluationSubmissionsQuery({
		variables: { userID, isArchived: false, last: 5 },
	});
	const [fetchArchived, archivedQuery] = graphql.useEvaluationSubmissionsLazyQuery({
		variables: { userID, isArchived: true, last: 5 },
	});

	return (
		<>
			{isConversationsAIInsightsEnabled && (
				<Announcement announcementID="2a7be615-758b-4202-a35d-9b6c45b9f6aa" />
			)}

			<Jumbo.Editable
				hasMediaUpload
				page={PageType.ConversationsPersonal}
				title={t('conversations.index.title')}
				description={t('conversations.index.description')}
				button={
					isAdhocEnabled && (
						<Button
							icon={<AddIcon />}
							title={t('conversations.index.new')}
							link="/conversations/request-from-moment"
						/>
					)
				}
				footer={<ViewerConversationTabs />}
			/>

			<IncomingConversationsList
				query={query}
				archivedQuery={archivedQuery}
				fetchArchived={fetchArchived}
			/>
		</>
	);
}
